import { Route, Routes } from "react-router-dom";
import Layout from "../Layout";
import AboutUs from "../pages/AboutUs";
import ForgetPassword from "../pages/auth/forgetpassword";
import Login from "../pages/auth/login/";
import Register from "../pages/auth/register";
import Home from "../pages/Home";
import JoinAgent from "../pages/JoinAgent";
import RequestSubmit from "../pages/JoinAgent/RequestSubmit";
import MyBooking from "../pages/MyBookings";
import MyProfile from "../pages/MyProfile";
import NotFound from "../pages/NotFound";
import PaymentConfirmation from "../pages/PaymentConfirmation";
import PaymentStatus from "../pages/PaymentStatus";
import TermsOfService from "../pages/TermsOfService";
import PreventNormalUserRoute from "./PreventNormalUserRoute";
import PreventRoute from "./PreventRoute";

export default function AllRoutes() {
  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/terms-condition" element={<TermsOfService />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/join-agent" element={<JoinAgent />} />
        <Route path="/my-bookings" element={<MyBooking />} />
        <Route path="/request-submit" element={<RequestSubmit />} />
        <Route path="/payment-status" element={<PaymentStatus />} />
        <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
        <Route path="/forget-password" element={<PreventRoute />}>
          <Route path="/forget-password" element={<ForgetPassword />} />
        </Route>
        <Route path="/sign-in" element={<PreventRoute />}>
          <Route path="/sign-in" element={<Login />} />
        </Route>
        <Route path="/create-new-account" element={<PreventNormalUserRoute />}>
          <Route path="/create-new-account" element={<Register />} />
        </Route>
        {/*
        <Route path="/under-maintenance" element={<UnderMaintenance />} />
        <Route path="/" element={<TemporarilyUnavailable />} /> 
        */}
      </Route>
    </Routes>
  );
}
